import React from 'react'

const Recruitment = () => {
  return (
    <div>Recruitment</div>
  )
}

export default Recruitment